import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Width reserved for center countdown / score / meta between names. */
const CENTER_LANE_WIDTH = 148;

export function getMatchHubHeroStyles(theme: Theme) {
  return StyleSheet.create({
    /** Stadium backdrop fills behind the content; overflow clips the pitch band. */
    hero: {
      position: 'relative',
      overflow: 'hidden',
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.xxxl,
      paddingHorizontal: theme.spacing.lg,
    },
    topBar: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing.xl,
    },
    topBarSide: {
      width: 44,
      justifyContent: 'center',
    },
    topBarSideRight: {
      width: 44,
    },
    topBarCenter: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: theme.spacing.sm,
    },
    leagueTitle: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.white,
      textAlign: 'center',
    },
    leagueSub: {
      fontSize: 12,
      fontWeight: '500',
      color: theme.white,
      opacity: 0.55,
      textAlign: 'center',
      marginTop: 2,
    },
    backButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
      shadowColor: theme.black,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.06,
      shadowRadius: 8,
      elevation: 3,
    },
    backButtonPressed: {
      opacity: 0.8,
    },
    matchupBlock: {
      marginTop: theme.spacing.sm,
    },
    /** Kits + main center stack (no bottom meta here — that sits with names). */
    kitsAndCenterRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    sideKitSlot: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    centerLane: {
      width: CENTER_LANE_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.sm,
    },
    /** Home name | kickoff / minute / Final | away name — one band, flush under kits. */
    namesAndMetaRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 2,
    },
    nameSide: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.xs,
    },
    nameCenterSlot: {
      width: CENTER_LANE_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.sm,
    },
    metaBetweenNames: {
      fontSize: 14,
      fontWeight: '500',
      color: theme.white,
      opacity: 0.5,
      textAlign: 'center',
    },
    metaBetweenNamesPlaceholder: {
      height: 20,
    },
    teamName: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.white,
      textAlign: 'center',
      maxWidth: 128,
      lineHeight: 17,
    },
    centerDate: {
      fontSize: 13,
      fontWeight: '500',
      color: theme.white,
      opacity: 0.5,
      marginBottom: 6,
    },
    centerPrimary: {
      fontSize: 32,
      fontWeight: '700',
      color: theme.white,
      letterSpacing: 0.5,
      textAlign: 'center',
      lineHeight: 38,
    },
    scoreLarge: {
      fontSize: 32,
      fontWeight: '700',
      color: theme.white,
      letterSpacing: 1,
      fontVariant: ['tabular-nums'],
      lineHeight: 38,
    },
  });
}
